import { CirclePlus, CreditCard } from "lucide-solid";
import type { SavedPaymentMethod } from "~/solidJs/shared/api/PaymentApi";
import { ADD_NEW_PAYMENT_METHOD_ID, type PaymentMethod } from "../model";

export const transformPaymentMethod = (method: SavedPaymentMethod): PaymentMethod => ({
	value: method.id,
	label: `${method.brand.toUpperCase()} *${method.last4}`,
	id: method.id,
	last4: method.last4,
	system: method.system,
	brand: method.brand,
	is_default: method.is_default,
	icon: CreditCard
});

export const createAddNewPaymentMethodItem = (): PaymentMethod => ({
	value: ADD_NEW_PAYMENT_METHOD_ID,
	label: "Add new payment method",
	id: ADD_NEW_PAYMENT_METHOD_ID,
	last4: "",
	brand: "",
	is_default: false,
	system: "new",
	icon: CirclePlus
});
